import AuthService from '../../service';
const onlineExhibition = {
  getOnlineExhibition(page,search,sort_date){
    return AuthService.get(`/resource_center/online_exhibition?`+
      `page=${page}` +
      `&sort_date=${sort_date}` +
      `&search=${search}`
    );
  },
  showOnlineExhibition(id){
    return AuthService.get(`/resource_center/online_exhibition/${id}`);
  },
  createOnlineExhibition(data){
    return AuthService.post(`/resource_center/online_exhibition`,data);
  },
  updateOnlineExhibition(id,data){
    return AuthService.put(`/resource_center/online_exhibition/${id}`,data);
  },
  deleteOnlineExhibition(id){
    return AuthService.delete(`/resource_center/online_exhibition/${id}`);
  },
}
export default onlineExhibition
